// src/components/ProtectedRoute.js
import { Navigate, useNavigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import HomePage from '../pages/HomePage';
import useAuth from "../hooks/useAuth";

const DefaultRoute = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    if (loading) return;
    
    if (!user) {
      navigate('/login', { replace: true });
      return;
    }
    
    // Определяем целевую страницу в зависимости от analytics_view
    const targetPath = '/';
    
    // Проверяем, не находимся ли уже на целевой странице
    if (location.pathname !== targetPath) {
      navigate(targetPath, { replace: true });
    }
  }, [loading, user, navigate, location]);

  // Показываем загрузку пока не определим куда направить
  if (loading || !user) {
    return <div>Загрузка...</div>;
  }

  // Возвращаем нужную страницу в зависимости от analytics_view
  return <HomePage /> ;
};

const ProtectedRoute = ({ 
  children, 
  requiredRoles = [], 
  forbiddenRoles = [], 
  oneOfRoles = [],
  redirectDefault = false 
}) => {
  const { user, loading } = useAuth();

  // Показываем лоадер пока идет проверка аутентификации
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '80vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Загрузка...</span>
        </div>
      </div>
    );
  }

  // Если пользователь не авторизован - редиректим на вход
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Получаем имена ролей пользователя
  const roleNames = new Set(user?.roles?.map(r => r.name) || []);

  // Проверка прав
  // const hasAccess = () => {
  //   if (!user) return false;
  //
  //   // Проверка запрещённых ролей
  //   if (forbiddenRoles.length > 0) {
  //     if (forbiddenRoles.some(role => roleNames.has(role))) {
  //       return false;
  //     }
  //   }
  //
  //   // Проверка обязательных ролей (все должны присутствовать)
  //   if (requiredRoles.length > 0) {
  //     // Если требуется роль superuser, то только superuser имеет доступ
  //     if (requiredRoles.includes('superuser')) {
  //       return user.superuser === true;
  //     }
  //     // Для остальных роле�� проверяем их наличие
  //     if (!requiredRoles.every(role => roleNames.has(role))) {
  //       return false;
  //     }
  //   }
  //
  //   // Проверка хотя бы одной из ролей
  //   if (oneOfRoles.length > 0) {
  //     if (!oneOfRoles.some(role => roleNames.has(role))) {
  //       return false;
  //     }
  //   }
  //
  //   // Если нет обязательных ролей и не сработали другие условия, доступ разрешён
  //   return true;
  // };

  // Если требуется перенаправление на основную страницу
  if (redirectDefault) {
    return <DefaultRoute />;
  }

  // Проверка прав доступа
  const hasAccess = () => {
    // Проверка запрещённых ролей
    if (forbiddenRoles.length > 0) {
      if (forbiddenRoles.some(role => roleNames.has(role))) {
        return false;
      }
    }
    
    // Проверка обязательных ролей (все должны присутствовать)
    if (requiredRoles.length > 0) {
      // Если требуется роль superuser, то только superuser имеет доступ
      if (requiredRoles.includes('superuser')) {
        return user.superuser === true;
      }
      // Для остальных ролей проверяем их наличие
      if (!requiredRoles.every(role => roleNames.has(role))) {
        return false;
      }
    }
    
    // Проверка хотя бы одной из ролей
    if (oneOfRoles.length > 0) {
      if (!oneOfRoles.some(role => roleNames.has(role))) {
        return false;
      }
    }
    
    // Если нет обязательных ролей и не сработали другие условия, доступ разрешён
    return true;
  };

  // Если нет доступа - редиректим на вход
  if (!hasAccess()) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
